import store  from "./store";
const getBaseurl= () => {
  const state = store.getState();
  return state.server?.BASE_URL 
};
const getApibaseurl = () => {
  const state = store.getState();
  return state.server?.API_BASE_URL 
};
export var BASE_URL = getBaseurl();
export var API_BASE_URL = getApibaseurl();

if (!BASE_URL || !API_BASE_URL) {
  throw new Error("Please define the BASE_URL and API_BASE_URL environment variables inside .env");
}
